import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

export default function DeleteCustomerDialog({ open, customer, onClose, onConfirm }) {
    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>Kunden löschen?</DialogTitle>
            <DialogContent dividers>
                <Typography>
                    Möchtest du „{`${customer?.name || ""} ${customer?.lastname || ""}`.trim()}“ wirklich löschen? Dieser Vorgang kann
                    nicht rückgängig gemacht werden.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit">
                    Abbrechen
                </Button>
                <Button color="error" onClick={onConfirm}>
                    Löschen
                </Button>
            </DialogActions>
        </Dialog>
    );
}
